export function splitContentImage(rawContent = "") {
  const splitIndex = rawContent.indexOf("<");

  if (splitIndex === -1) {
    return {
      image: "",
      content: rawContent,
    };
  }

  return {
    image: rawContent.substring(0, splitIndex),
    content: rawContent.substring(splitIndex),
  };
}
